import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const Wrapper = styled.div<{ $frameOpen?: boolean }>`
  display: flex;
  align-items: stretch;
  gap: 0;
  width: 100%;
  height: 40px;

  ${({ $frameOpen }) =>
    $frameOpen &&
    css`
      border: 1px solid ${COLORS.primaryDark};
      border-radius: 4px;
      overflow: hidden;
    `}
`

export const StepButton = styled.button<{ $frameOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  min-width: 38px;
  height: 100%;
  padding: 0;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  line-height: 1;
  background: ${COLORS.white};
  color: ${COLORS.secondaryDark};
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;

  ${({ $frameOpen }) =>
    $frameOpen
      ? css`
          border-radius: 0 !important;
          border-top: none !important;
          border-bottom: none !important;

          &:first-of-type {
            border-left: none !important;
            border-right: 1px solid ${COLORS.borderColor};
          }

          &:last-of-type {
            border-right: none !important;
            border-left: 1px solid ${COLORS.borderColor};
          }
        `
      : css`
          &:first-of-type {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          &:last-of-type {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        `}

  &:hover {
    border-color: ${COLORS.secondarySemiLight};
  }

  &:active {
    background: ${COLORS.primaryLight};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const DropdownWrapper = styled.div<{
  $isOpen?: boolean
  $frameOpen?: boolean
}>`
  flex: 1;
  min-width: 0;

  > div {
    height: 40px;
  }

  > div > div:first-of-type {
    border-radius: 0;
    border-left: none !important;
    border-right: none !important;
    border-top: 1px solid
      ${({ $isOpen, $frameOpen }) =>
        $frameOpen
          ? 'transparent'
          : $isOpen
            ? COLORS.primaryDark
            : COLORS.borderColor};
    border-bottom: 1px solid
      ${({ $isOpen, $frameOpen }) =>
        $frameOpen
          ? 'transparent'
          : $isOpen
            ? COLORS.primaryDark
            : COLORS.borderColor};
    background: ${({ $isOpen }) =>
      $isOpen ? COLORS.primaryLight : COLORS.white};
    box-shadow: none;
    transition:
      background 0.2s,
      border-color 0.2s;

    &::before {
      display: none !important;
      content: none !important;
    }

    &:hover {
      /* border-left: none !important;
      border-right: none !important;
      border-top-color: ${({ $isOpen, $frameOpen }) =>
        $frameOpen
          ? 'transparent'
          : $isOpen
            ? COLORS.primaryDark
            : COLORS.secondarySemiLight};
      border-bottom-color: ${({ $isOpen, $frameOpen }) =>
        $frameOpen
          ? 'transparent'
          : $isOpen
            ? COLORS.primaryDark
            : COLORS.secondarySemiLight}; */
      background: ${({ $isOpen }) =>
        $isOpen ? COLORS.primaryLight : COLORS.primaryLight};
    }
  }
`

export const ValueTriggerInner = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 100%;
`

const valueFieldTypography = css`
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  color: ${COLORS.secondarySemiDark};
  text-align: center;
`

/** Closed state: full area; click bubbles to Dropdown to open. */
export const ValueDisplay = styled.span`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 4px;
  cursor: text;
  ${valueFieldTypography}
`

export const ValueInput = styled.input`
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 4px;
  border: none;
  background: transparent;
  outline: none;
  ${valueFieldTypography}

  &::placeholder {
    color: ${COLORS.secondarySemiLight};
  }
`

export const PresetList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
  max-height: 240px;
  overflow-y: auto;
`

/** Bottom sheet list — matches mobile option drawer spacing */
export const MobilePresetList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 16px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  ${customizeVerticalScrollbarThumbMixin()}
`
